// Navigation service that works both inside and outside Router context
export class NavigationService {
  private static navigate: ((path: string) => void) | null = null;
  
  static setNavigate(navigateFunction: (path: string) => void) {
    this.navigate = navigateFunction;
  }
  
  static navigateTo(path: string) {
    if (this.navigate) {
      this.navigate(path);
    } else {
      // Fallback to window.location if navigate is not available
      window.location.href = path;
    }
  }
  
  static isNavigateAvailable(): boolean {
    return this.navigate !== null;
  }
}